import axios from "@/lib/axios";
import { SpringPage, SpringPageableRequest } from "@/types/apis";

export type ListResourcesRequestParams = SpringPageableRequest & {
  companyId: string;
  resourceLibraryId: string;
  q: string;
  types: ListResourcesResponseContentType[];
};

export type ListResourcesResponseContentType = "FILE" | "LINK";

export type ListResourcesResponseContent = {
  id: string;
  name: string;
  description: string | null;
  fileName: string | null;
  objectId: string | null;
  url: string | null;
  type: ListResourcesResponseContentType;
  uploadDate: string;
  tags: string[];
};

export type ListResourcesResponse = SpringPage<ListResourcesResponseContent>;

export const listResources = (params: ListResourcesRequestParams) =>
  axios
    .get<ListResourcesResponse>(
      `/v1/companies/${params.companyId}/resource-libraries/${params.resourceLibraryId}/resources`,
      {
        params: {
          q: params.q,
          types: params.types,
          page: params.page,
          size: params.size,
          sort: params.sort,
        },
      },
    )
    .then((res) => res.data);
